// API配置
// 注意：开发环境通过 Vite proxy 转发到后端，生产环境通过 Nginx 反向代理
// baseURL 为空字符串，因为服务层的 baseUrl 已经包含了 /api 前缀
export const API_CONFIG = {
  baseURL: '', // 使用相对路径，由 Vite proxy 或 Nginx 转发
  timeout: 30000, // 默认30秒
  longTimeout: 240000, // AI分析等长时间操作使用240秒
}